/**
 * Composable for formatting 10-digit phone numbers for backend/RIMS and web app display.
 * @returns {object} An object containing the formatting functions.
 */
export function usePhoneFormatter() {

  /**
   * Formats a 10-digit phone number for backend/RIMS requirements.
   * Assumes the input `str` is exactly 10 digits.
   * Example: "1234567890" becomes "1-(123)-456-7890"
   * @param {string} str The 10-digit phone number string.
   * @returns {string} The formatted phone number string or the original string if invalid length.
   */
  const formatPhoneForRims = (str) => {
    if (str?.length === 10) {
      return `1-(${str.substring(0, 3)})-${str.substring(3, 6)}-${str.substring(6)}`;
    }
    return str;
  };

  /**
   * Formats a phone number string for web app display, extracting the last 10 digits if longer.
   * Removes parentheses and hyphens, and extracts the last 10 digits.
   * @param {string} str The phone number string, potentially with formatting or extra digits.
   * @returns {string} The cleaned 10-digit phone number string for web app display.
   */
  const formatPhoneForWebapp = (str) => {
    if (str) {
      const tmp = str.replaceAll('(', '').replaceAll(')', '').replaceAll(/-/g, '');const digits = 10;
      const length = tmp.length;
      if (length > digits) {
        return tmp.substring(length - digits); // Get the last 10 digits
      } else {
        return tmp;
      }
    }
    return str;
  };

  return {
    formatPhoneForRims,
    formatPhoneForWebapp,
  };
}